import InnerGreetingsPostcardApp from "../components/app/greetings-postcard-app/InnerGreetingsPostcardApp";

const GreetingsAppPage = InnerGreetingsPostcardApp

export default GreetingsAppPage